import { appEnv, projectId } from '../env.ts';
import { ClientLogger } from './client.ts';
import { ServerLogger } from './server.ts';

export type LogLevel = keyof Logger;
export type Data = unknown;

export type Logger = {
  log: (message: unknown, data?: Data) => void;
  info: (message: unknown, data?: Data) => void;
  warn: (message: unknown, data?: Data) => void;
  error: (message: unknown, data?: Data) => void;
};

export const logger =
  typeof document !== 'undefined' ? new ClientLogger() : new ServerLogger(appEnv, projectId);
